import React, { Component } from 'react';
import { Outlet, useNavigate } from 'react-router-dom';
import { connect } from 'react-redux';
import * as reducers from '../../store/reducers';
import * as mediaActions from '../../store/media/actions';

import ErrorPage from 'Screens/ErrorPage';
import Loading from 'Components/Loading';

import { withLocationWrapper } from '../../utils/HOC_LocationWrapper';


class VideoSeries extends Component {
  componentDidMount() {
    if (!this.props.children) this.fetchData();
  }

  componentDidUpdate(prevProps) {
    if (this.props.slug !== prevProps.slug && !this.props.children) {
      this.fetchData();
    }
  }

  fetchData() {
    const { slug, fetchMedia } = this.props;
    const qs = {
      'include-nested': 'videos',
    };
    fetchMedia(slug, qs);
  }

  render() {
    const { errors, isFetching, firstVideo } = this.props;
    if (this.props.children) return this.props.children;
    if ((errors.media || errors.lists) && !firstVideo) {
      return (
        <ErrorPage
          errorCode="404"
          errorType="pageNotFound"
          errorMessage={errors.media.message}
        />
      );
    }
    if (isFetching || !firstVideo) {
      return <Loading />;
    }

    if (firstVideo && firstVideo.slug) {
      const newPath = `${this.props.location.pathname}/${firstVideo.slug}`;
      this.props.navigate(newPath);
    }
    // return <div>{this.props.children}</div>;
    return ( <Outlet /> );
  }
}

const mapStateToProps = (state, { params }) => {
  return {
    slug: params.seriesID,
    firstVideo: reducers.getFirstVideoInSeries(state, params.seriesID),
    isFetching: reducers.getIsMediaFetching(state),
    errors: reducers.getErrors(state),
  };
};

const VideoSeriesComponent = connect(mapStateToProps, mediaActions)(VideoSeries);

export default withLocationWrapper(VideoSeriesComponent);
